export default {

    //用户身份信息
    user:{},
    
}


// WEBPACK FOOTER //
// ./src/vuex/user/state.js